// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__2-Uam","activeLink":"NavLink_activeLink__1LQO0"};